import React from 'react'

import {
    StyledInHouseLinks,
    StyledLink,
    StyledReturnLink,
} from 'component-library/navigation/TheWestMainNavigation/components/in_house_links/in_house_links.styled'
import { TheWestReturn } from 'component-library/navigation/TheWestReturn/TheWestReturn'

export interface InHouseLink {
    text: string
    link: string
    target?: string
    rel?: string
}

export interface Props {
    items: InHouseLink[]
    isRegionalSite: boolean
}

const InHouseLinks: React.FC<Props> = ({ items, isRegionalSite }) => {
    const linkStyle = isRegionalSite ? 'regional' : 'standard'

    return (
        <StyledInHouseLinks linksStyle={linkStyle} className="in-house-links">
            {items.map(({ text, link, target, rel }) => (
                <StyledLink linkStyle={linkStyle} key={link} to={link} rel={rel} target={target}>
                    {text}
                </StyledLink>
            ))}
            {isRegionalSite && (
                <StyledReturnLink to={'https://thewest.com.au'} isPrimary={true}>
                    <TheWestReturn />
                </StyledReturnLink>
            )}
        </StyledInHouseLinks>
    )
}

export default InHouseLinks
